
import { Play, Pause, Volume2, VolumeX, Loader2, Share2 } from "lucide-react";
import { Slider } from "@/components/ui/slider";
import { copy } from "@/components/listen/StreamLinks";

export const BottomBar = ({ status, audio, vol }) => {
  const { volume, setVolume, toggleMute } = vol;
  const np = status?.now_playing;

  return (
    <div className="fixed bottom-0 inset-x-0 z-40 bottom-bar" data-testid="bottom-player-bar">
      <div className="max-w-5xl mx-auto px-3 sm:px-5 py-2.5 flex items-center gap-2 sm:gap-3">
        <button onClick={audio.toggle} disabled={audio.loading} className="hw-btn rounded-lg w-14 h-11 flex items-center justify-center shrink-0"
          data-testid={audio.playing ? "public-player-pause-button" : "public-player-play-button"} aria-label={audio.playing ? "Pause" : "Play"}>
          {audio.loading ? <Loader2 className="w-5 h-5 animate-spin hw-icon" /> : audio.playing ? <Pause className="w-5 h-5 hw-icon" /> : <Play className="w-5 h-5 hw-icon" />}
        </button>
        <div className="lcd rounded-lg px-3 py-1.5 flex-1 min-w-0">
          <p className="text-sm font-bold truncate lcd-text" data-testid="bottom-bar-title">{np ? [np.artist, np.title].filter(Boolean).join(" - ") : "Station idle"}</p>
          <p className="text-[0.65rem] flex items-center gap-1.5 lcd-text opacity-70">
            <span className={`w-1.5 h-1.5 rounded-full ${audio.playing ? "lcd-glow" : ""}`} style={{ background: audio.playing ? "var(--t-label)" : "currentColor" }} />
            {audio.playing ? (status?.live ? "live on air" : "playing") : "idle"}
          </p>
        </div>
        <button onClick={() => copy(window.location.origin, "Station link copied")} className="hw-btn rounded-lg w-11 h-11 hidden sm:flex items-center justify-center shrink-0" aria-label="Share" data-testid="bottom-bar-share-button">
          <Share2 className="w-4 h-4 hw-icon" />
        </button>
        <button onClick={toggleMute} className="hw-btn rounded-lg w-11 h-11 flex items-center justify-center shrink-0" data-testid="public-player-mute-button" aria-label="Mute">
          {volume ? <Volume2 className="w-4 h-4 hw-icon" /> : <VolumeX className="w-4 h-4 hw-icon" />}
        </button>
        <Slider value={[volume]} max={100} step={1} onValueChange={(v) => setVolume(v[0])} className="w-20 sm:w-32 lr-volume shrink-0" data-testid="public-player-volume-slider" />
      </div>
    </div>
  );
};
